module.exports = __webpack_public_path__ + "static/media/hike-ruck.86787c85.jpg";